//interface

export const AlignType = 'left' | 'center' | 'right' | 'justify ';
export const DirectionType = 'ltr' | 'rtl';


const  Interface = {

    isNull(value){
        return value === undefined || value === null;
    },

    isEmptyString(value){
        if(this.isNull(value)){
            return true;
        }
        if (typeof value === 'string' || value instanceof String){
            return ((value.trim() === "") || (value === "") || (value === null));
        }
        return true;
    },

    isFunction(value){
        if(this.isNull(value)){
            return false;
        }
        return (value instanceof Function);
    },

    isNumber(value){
        if (typeof value === 'number') {
            return true;
        }
        return false;
    },

    indexParent(el){
        const nodes = Array.prototype.slice.call( el.parentNode.childNodes );
        return nodes.indexOf(el);
    },

    isArray(input) {
        return Object.prototype.toString.call(input) === "[object Array]";
    },

    mod (a, b) {
        return Math.abs(a - (b * Math.floor(a / b)));
    },

    recreateNode(el, withChildren=false) {
        let newEl;
        if (withChildren) {
            newEl=el.cloneNode(true);
            el.parentNode.replaceChild(newEl, el);
        }
        else {
            newEl = el.cloneNode(false);
            while (el.hasChildNodes()) newEl.appendChild(el.firstChild);
            el.parentNode.replaceChild(newEl, el);
        }
        return newEl;
    },

    // Can I use transition ?
    transitionSupported (){
        var style = document.createElement('div').style;
        return 'transition' in style ||
            'WebkitTransition' in style ||
            'MozTransition' in style ||
            'msTransition' in style ||
            'OTransition' in style;
    },

    rmArray (arr,value) {
        let index = arr.indexOf(value);
        if (index > -1 && index<arr.length) {
            arr.splice(index, 1);
        }
        return arr;
    },

    hasValueArray (arr,value) {
        let index = arr.indexOf(value);
        if (index > -1 && index<arr.length) {
            return true;
        }
        return false;
    },

    isBodyRtl(){
        return  document.body.classList.contains("rtl");
    },

    disableRightClick (element){
        element.addEventListener('contextmenu', e => {
            e.preventDefault();
        });
    },

    getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    },

    getSeletedValue  (element){
        let value="";
        let items = element.querySelectorAll('[selected]');
        let numS=items.length;
        if(numS>0){
            value = items[0].value;
        }
        value=value.trim();
        if(Interface.isEmptyString(value)){
            value="";
        }
        return value;
    },

    setSeletedValue  (element,value){
        let items = element.querySelectorAll('[selected]');
        items.forEach(function (item) {
            item.removeAttribute('selected');
        });

        let items1 = element.querySelectorAll('option[value="' + value + '"]');
        items1.forEach(function (item) {
            item.setAttribute("selected", "selected");
        });
    },

    insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    },

    toEnglishDigits(val) {
        if(Boolean(val)){
            let str=val.toString();
            // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
            var e = '۰'.charCodeAt(0);
            str = str.replace(/[۰-۹]/g, function(t) {
                return t.charCodeAt(0) - e;
            });
        
            // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
            e = '٠'.charCodeAt(0);
            str = str.replace(/[٠-٩]/g, function(t) {
                return t.charCodeAt(0) - e;
            });
            return str;
        }else return val;
    },




}

export default Interface;
